import { selectUpdateFavoriteLoading } from "app/components/Sidebar/components/Favorite/Redux/selector";
import { actions } from "app/components/Sidebar/components/Favorite/Redux/slice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

type UpdateCallback = () => void;

export const useUpdateFavorite = () => {
  const dispatch = useDispatch();

  const updateFavoriteLoading = useSelector(selectUpdateFavoriteLoading);

  const updateFavorite = (
    itemId: string,
    type: string,
    callback?: UpdateCallback,
  ) => {
    dispatch(
      actions.updateFavoriteStatusRequest({
        data: { itemId, type },
        callback: callback ?? (() => {}),
      }),
    );
  };

  return {
    updateFavorite,
    updateFavoriteLoading,
  };
};
